// extracted by mini-css-extract-plugin
export default {"root":"BlockFooter_root__EPBK9","media":"BlockFooter_media__62giB","text":"BlockFooter_text__8vQ4I"};